import { Injectable, Component } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppSettings } from '../configuration/appsettings.config'
import { AutherizationService } from './autherization.service'
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';


@Injectable()
export class AuthGuard  {
  constructor(private router: Router, private autherizationService: AutherizationService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let isvalid = false;
     
      switch (state.url) {

          case "/disclaimer":
              isvalid = true;
              if (AppSettings.isPIDTokenExists()) {
                  isvalid = true;
              }
              else {
                  this.redirectInavlidLink();
              }
              break;
          case "/welcome":
              if (AppSettings.isPIDTokenExists() && AppSettings.isCapchaTokenExists()) {
                  isvalid = true;
              }
              else {
                  this.redirectInavlidLink();
              }
              break;
          case "/form":
              isvalid = true;
              // 
              if (AppSettings.isPIDTokenExists() && AppSettings.isCapchaTokenExists()) {
                  isvalid = true;
              }
              else {
                  this.redirectInavlidLink();
              }
              break;
          case "/documents":
              isvalid = true;
              // 
              if (AppSettings.isPIDTokenExists() && AppSettings.isCapchaTokenExists()) {
                  isvalid = true;
              }
              else {
                  this.redirectInavlidLink();
              }
              break;

          case "/review":
              //&& 
              if (AppSettings.isPIDTokenExists() && AppSettings.isCertificationIdExists() && AppSettings.isCapchaTokenExists()) {
                  isvalid = true;
              }
              else {
                  this.redirectInavlidLink();
              }
              break;
          case "/complete":

              isvalid = true;
              ////&& AppSettings.isCapchaTokenExists()  
              if (AppSettings.isReferenceNoExists() && AppSettings.isPIDTokenExists() && AppSettings.isCapchaTokenExists()) {
                  isvalid = true;
              }
              else {
                  this.redirectInavlidLink();
              }
              break;
      }
    return of(isvalid);

  }

  redirectInavlidLink() {
    this.router.navigate(['/link']);
  }

  isEmpty(obj) {
    var isEMpty = true;
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        isEMpty = false;
      return;
    }
    return isEMpty;

  }


}
